export class RestoreGcpVmInstanceRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "GcpVmInstanceRestoreDestination",
            "format": ""
        },
        {
            "name": "sqlVmPitrRestore",
            "baseName": "sqlVmPitrRestore",
            "type": "SqlVmPitrRestoreProperties",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreGcpVmInstanceRequest.attributeTypeMap;
    }
    constructor() {
    }
}
